import { css } from "@emotion/css";
import { accessibilityStyles, resetStyles } from "@octopusdeploy/design-system-components";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import { ProcessOverviewStepAction, type ProcessOverviewStepActionData } from "~/areas/projects/components/Process/ProcessOverview/ProcessOverviewStepAction";
import { ProcessOverviewStepContainer, type ProcessOverviewStepContainerData } from "~/areas/projects/components/Process/ProcessOverview/ProcessOverviewStepContainer";
export type ProcessOverviewStepData = ProcessOverviewStepActionData | ProcessOverviewStepContainerData;
export type ProcessOverviewRootStep = ProcessOverviewStepData & {
    stepNumber: number;
};
export interface ProcessOverviewProps {
    steps: ProcessOverviewRootStep[];
    showNote: boolean;
}
export function ProcessOverview({ steps, showNote }: ProcessOverviewProps) {
    return (<ol className={styles.root}>
            {steps.map((step) => (<li key={step.id} className={styles.stepListItem}>
                    <div className={styles.stepNumber}>
                        <span className={styles.stepAccessibilityPrefix}>Step&nbsp;</span>
                        {step.stepNumber}
                    </div>
                    {isStepContainer(step) ? (<ProcessOverviewStepContainer key={step.id} stepContainerData={step} showNote={showNote} isRootStep={true}/>) : (<ProcessOverviewStepAction key={step.id} stepActionData={step} showNote={showNote} isRootStep={true}/>)}
                </li>))}
        </ol>);
}
export function isStepContainer(step: ProcessOverviewStepData): step is ProcessOverviewStepContainerData {
    return "containerSteps" in step;
}
const styles = {
    root: css({
        ...resetStyles.list,
        // There is z-index used by RunInParallelIndicator inside ProcessOverviewStep component,
        // this isolation is needed to prevent z-index leaking.
        isolation: "isolate",
        display: "flex",
        flexDirection: "column",
        gap: space[8],
        maxWidth: "78.75rem",
    }),
    stepListItem: css({
        position: "relative",
        display: "flex",
        gap: space[12],
    }),
    stepNumber: css({
        display: "flex",
        // This minWidth and marginLeft allows the number to bleed out into the left side padding if numbers get to triple or more digits
        minWidth: "1.875rem",
        marginLeft: `-${space[16]}`,
        justifyContent: "flex-end",
        font: text.body.regular.xSmall,
        color: themeTokens.color.text.secondary,
        padding: `${space[12]} 0`,
    }),
    stepAccessibilityPrefix: css({
        ...accessibilityStyles.hidden,
    }),
};
